import { dynamicImage } from "../../Services";

export const usage = [
  {
    id: 1,
    browser: "Google Chrome",
    Daily: "28%",
    Weekly: "76%",
    Monthly: "36%",
    img: dynamicImage("dashboard/chrom.png"),
  },
  {
    id: 2,
    browser: "Mozilla Firefox",
    Daily: "28%",
    Weekly: "76%",
    Monthly: "36%",
    img: dynamicImage("dashboard/firefox.png"),
  },
  {
    id: 3,
    browser: "Mozilla Firefox",
    Daily: "28%",
    Weekly: "76%",
    Monthly: "36%",
    img: dynamicImage("dashboard/safari.png"),
  },
  {
    id: 4,
    browser: "Opera (web browser)",
    Daily: "28%",
    Weekly: "76%",
    Monthly: "36%",
    img: dynamicImage("dashboard/opera.png"),
  },
];
